<template>
  <Col span="24">
    <Table style="margin-bottom: 10px;" v-if="showTable" :columns="columns" :data="dataSource"></Table>
    <div v-else style="min-height: 300px; width: 100%;position: relative; margin-bottom: 10px" ref="line"></div>
  </Col>
</template>
<script>
const echarts = require("echarts/lib/echarts");
require("echarts/lib/component/grid");
require("echarts/lib/chart/line");
require('echarts/lib/component/dataZoom');
require('echarts/lib/component/tooltip')
export default {
  props: {
    type: {
      type: Number | String,
      default: "",
    },
    dataSource: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      columns: [
        {
          title: "填写时间",
          align: "center",
          key: "time",
        },
        {
          title: "填写记录",
          align: "center",
          key: "value",
        },
      ],
      chart: null,
      showTable: false
    };
  },
  watch: {
    dataSource: {
      handler() {
        this.drawChart();
      },
      deep: true,
    },
  },
  mounted() {
    this.chart = echarts.init(this.$refs.line);
    this.drawChart();
  },
  methods: {
    showLoading() {
      if (this.chart) {
        this.chart.showLoading({
          text: "加载中",
          color: "#5e80f8",
          textColor: "#5e80f8",
          maskColor: "rgba(255, 255, 255, 0.1)",
          zlevel: 0,
        });
      }
    },
    hideLoading() {
      if (this.chart) {
        this.chart.hideLoading();
      }
    },
    drawChart() {
      if (this.type !== 0 && this.dataSource.find(d => isNaN(Number(d.value)))) {
        this.showTable = true;
      } else {
        this.showTable = false;
        this.chart.setOption({
          grid: {
            bottom: 80
          },
          xAxis: {
            type: "category",
            data: this.dataSource.map((d) => d.time),
            nameLocation: 'center',
            axisLabel: {
              formatter: function (value) {
                return value.slice(0, 10) + '\n' + value.slice(11);
              },
            }
          },
          yAxis: {
            type: "value",
          },
          series: [
            {
              data: this.dataSource.map((d) => {
                if (this.type === 0) {
                  return d.score;
                } else {
                  return d.value
                }
              }),
              type: "line",
            },
          ],
          tooltip: {
            trigger: "axis",
            formatter: "{b}<br/>{c}",
          },
          dataZoom: [
            {
              id: 'dataZoomX',
              type: 'slider',
              show: this.dataSource.length > 10,
              xAxisIndex: [0],
              start:
                this.dataSource.length > 10
                  ? parseInt(((this.dataSource.length - 10) / this.dataSource.length) * 100)
                  : 0,
              end: 100,
              textStyle: {
                fontSize: 10
              },
              bottom: 0,
            }
          ],
        });
      }
    },
  },
};
</script>
<style lang="less"></style>
